import {clusterize} from "../utils/breakpoints";

export const getClusterFunction = () => {
    const { breakpointClusters } = WP_OctaviusRocks_Admin;
    return (typeof window.Octavius_Rocks_breakpointsCluster === "function") ?
        window.Octavius_Rocks_breakpointsCluster
        :
        (breakpoints)=> clusterize(breakpoints, breakpointClusters);
}

export const useBreakpoints = (values)=>{
    const clusterize = getClusterFunction();
    return clusterize(values);
}